import { Box, Button } from "@mui/material";
import { useHistory } from "react-router";
import * as Routes from "routes";
import { CallCounter } from "./call-counter";
import { DemoControls } from "./demo-controls";
import {
  PredictiveSuburbManager,
  usePredictiveSuburbManager,
} from "./predictive-suburb-manager";
import { SuburbEntryForm } from "./suburb-entry-form";
import { VisualiseJson } from "./visualise-json";
import { VisualiseMap } from "./visualise-map";

export const predictiveSuburb = () => {
  const predictiveManager: PredictiveSuburbManager =
    usePredictiveSuburbManager();
  const history = useHistory();

  const jsonObj = predictiveManager.suggest ?? predictiveManager.locality ?? {};
  //@ts-ignore
  const { basictransaction, ...objWithoutBasictransaction } = jsonObj;

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Button
        variant="contained"
        size="small"
        sx={{ alignSelf: "flex-end", top: "-55px" }}
        onClick={() => {
          history.push(Routes.demosPage);
        }}
      >
        Back
      </Button>
      <DemoControls {...predictiveManager}></DemoControls>
      <Box display="flex" flexDirection="row" gap={2}>
        <Box display="flex" flexDirection="column" width="100%" gap={2}>
          <SuburbEntryForm {...predictiveManager} />
          <VisualiseJson object={objWithoutBasictransaction} />
        </Box>
        <Box display="flex" flexDirection="column" width="100%" gap={2}>
          <CallCounter {...predictiveManager} />
          <VisualiseMap {...predictiveManager} />
        </Box>
      </Box>
    </Box>
  );
};
